import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  IonApp,
  IonSplitPane,
  IonRouterOutlet,
} from '@ionic/angular/standalone';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { LoaderComponent } from './components/loader/loader.component';
import { MenuComponent } from './components/menu/menu.component';
import { CookieBannerComponent } from './components/cookie-banner/cookie-banner.component';
import { UtilsService } from './services/utils.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [
    CommonModule,
    IonApp,
    IonSplitPane,
    IonRouterOutlet,
    LoaderComponent,
    MenuComponent,
    CookieBannerComponent
  ],
  providers: [],
})
export class AppComponent implements OnInit {
  constructor(private router: Router, private utilsService: UtilsService) {}

  ngOnInit(): void {
    this.utilsService.captureUtmParams();

    // First load
    this.pushVirtualPageView(this.router.url || '/');

    // SPA route changes
    this.router.events
      .pipe(filter((evt): evt is NavigationEnd => evt instanceof NavigationEnd))
      .subscribe((evt: NavigationEnd) => {
        this.pushVirtualPageView(evt.urlAfterRedirects || evt.url || '/');
      });
  }

  private pushVirtualPageView(path: string): void {
    this.utilsService.captureUtmParams();
    this.utilsService.pushDataLayerEvent('virtual_page_view', {
      path: path,
    });
  }
}
